// extracted by mini-css-extract-plugin
module.exports = {"video-attachment__inner":"video-attachment__inner__1-nfC"};